export default function SupportProduct() {
  return (
    <div className="flex flex-col w-full overflow-auto justify-center items-center p-4" />

  );
}
